import React from 'react';
import { I18n } from '@aws-amplify/core';
import { FormItemWrapper, LabelMediumRegular } from '@/components/Settings/DataExtraction/styles';
import * as S from './styles';

export function FinalDateFormItem(): JSX.Element {
	return (
		<FormItemWrapper
			name="end_date"
			label={<LabelMediumRegular>{I18n.get('Final date')}</LabelMediumRegular>}
			labelCol={{ span: 24 }}
		>
			<S.CustomDatePicker
				format="L"
				placeholder={I18n.get('Final date')}
				disabledDate={(currentDate) => currentDate && currentDate.valueOf() > Date.now()}
			/>
		</FormItemWrapper>
	);
}
